/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SterWebsiteModelPriceCompareLabelValuePair,
  SterWebsiteModelPriceCompareLabelValuePairFromJSON,
  SterWebsiteModelPriceCompareLabelValuePairFromJSONTyped,
  SterWebsiteModelPriceCompareLabelValuePairToJSON,
} from "./";

/**
 *
 * @export
 * @interface SterWebsiteModelPriceComparePackage
 */
export interface SterWebsiteModelPriceComparePackage {
  /**
   *
   * @type {boolean}
   * @memberof SterWebsiteModelPriceComparePackage
   */
  fullWeek?: boolean;
  /**
   *
   * @type {number}
   * @memberof SterWebsiteModelPriceComparePackage
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceComparePackage
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceComparePackage
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceComparePackage
   */
  helpText?: string;
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareLabelValuePair>}
   * @memberof SterWebsiteModelPriceComparePackage
   */
  children?: Array<SterWebsiteModelPriceCompareLabelValuePair>;
}

export function SterWebsiteModelPriceComparePackageFromJSON(
  json: any
): SterWebsiteModelPriceComparePackage {
  return SterWebsiteModelPriceComparePackageFromJSONTyped(json, false);
}

export function SterWebsiteModelPriceComparePackageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceComparePackage {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fullWeek: !exists(json, "fullWeek") ? undefined : json["fullWeek"],
    id: json["id"],
    label: json["label"],
    value: json["value"],
    helpText: !exists(json, "helpText") ? undefined : json["helpText"],
    children: !exists(json, "children")
      ? undefined
      : (json["children"] as Array<any>).map(
          SterWebsiteModelPriceCompareLabelValuePairFromJSON
        ),
  };
}

export function SterWebsiteModelPriceComparePackageToJSON(
  value?: SterWebsiteModelPriceComparePackage | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fullWeek: value.fullWeek,
    id: value.id,
    label: value.label,
    value: value.value,
    helpText: value.helpText,
    children:
      value.children === undefined
        ? undefined
        : (value.children as Array<any>).map(
            SterWebsiteModelPriceCompareLabelValuePairToJSON
          ),
  };
}
